import { Box, Button, Typography } from "@mui/material";
import { generatePath, useNavigate } from "react-router-dom";
import { Organization } from "../../models/Organization";
import { HankoSecondaryCard } from "./HankoSecondaryCard";
import { Add } from "@mui/icons-material";
import { ReactComponent as Sparkle } from "../../assets/sparkle.svg";

interface Props {
  organization: Organization
}

export const UpgradeCard = (props: Props) => {
  const navigate = useNavigate()

  return <HankoSecondaryCard>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Box sx={{ position: 'relative' }}>
        <Add height="28px" width="28px"
             sx={{ height: '28px', width: '28px', border: '1.18px solid #262B35', borderRadius: '4.71px' }} />
        <Sparkle style={{ position: 'absolute', top: '-7px', left: '40px' }} />
        <Sparkle style={{ position: 'absolute', top: '6px', left: '60px' }} />
      </Box>
      <Typography variant="body1" sx={{ fontWeight: 500 }}>To add more projects please upgrade to Pro.</Typography>
    </Box>
    <Button variant="contained" sx={{ marginLeft: "auto" }}
            onClick={() => navigate(generatePath("/organizations/:organizationId/billing", { organizationId: props.organization.id }))}>Upgrade</Button>
  </HankoSecondaryCard>
}